import { Link } from 'react-router-dom'
import Seo from '@/components/Seo'
import SiteLayout from '@/components/SiteLayout'
import PageHero from '@/components/PageHero'
import CtaBand from '@/components/CtaBand'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { faqs, faqPage } from '@/content/faq'
import { heroImageOf } from '@/content/applyImages'

export default function FaqPage() {
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  }

  return (
    <SiteLayout>
      <Seo
        title={faqPage.seoTitle}
        description={faqPage.seoDescription}
        path={faqPage.path}
        image={heroImageOf(faqPage)}
        jsonLd={faqJsonLd}
      />
      <PageHero
        title={faqPage.hero.title}
        description={faqPage.hero.description}
        image={heroImageOf(faqPage)}
        showCta={false}
        eyebrow="Support"
      />
      <section className="py-16 bg-background">
        <div className="container mx-auto max-w-4xl px-6">
          <Accordion>
            {faqs.map((faq, index) => (
              <AccordionItem key={index} index={index}>
                <AccordionTrigger>{faq.question}</AccordionTrigger>
                <AccordionContent>
                  <p>{faq.answer}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <p className="text-center text-muted-foreground mt-10">
            Still have questions?{' '}
            <a href="mailto:services@tilliopayment.com" className="text-primary hover:underline">
              Email services@tilliopayment.com
            </a>
            {' '}or visit our{' '}
            <Link to="/pricing" className="text-primary hover:underline">pricing</Link>
            {' '}and{' '}
            <Link to="/hardware" className="text-primary hover:underline">hardware</Link>
            {' '}pages.
          </p>
        </div>
      </section>
      <CtaBand />
    </SiteLayout>
  )
}
